import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/data/content";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative overflow-hidden py-24 sm:py-32">
    <div className="mx-auto grid max-w-6xl items-center gap-16 px-5 lg:grid-cols-2">
      <Reveal className="relative order-2 lg:order-1">
        <div aria-hidden className="absolute -left-6 -top-6 h-full w-full rounded-[2.5rem] border border-peach/40" />
        <img
          src={IMAGES.about}
          alt="Fouzia Tarannum in a mentoring session"
          data-testid="about-portrait"
          className="relative h-[26rem] w-full rounded-[2.5rem] object-cover shadow-[0_35px_70px_-30px_rgba(216,98,88,0.4)] sm:h-[30rem]"
        />
        <div className="absolute -bottom-6 right-4 rounded-2xl border border-peach/25 bg-cream px-5 py-4 shadow-xl sm:-right-6">
          <p className="font-display text-2xl tracking-wide text-peach-dark">Biochemistry</p>
          <p className="font-heading text-[11px] font-semibold uppercase tracking-[0.2em] text-ink-subtle">
            Researcher → Mentor
          </p>
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <Overline>Meet Fouzia Tarannum</Overline>
          <h2 className="mt-4 font-heading text-2xl font-extrabold leading-tight tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Helping You Become Who You're Truly Capable Of Becoming
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 text-base leading-relaxed text-ink-muted sm:text-lg">
            I began with a Master's in Biochemistry, deep in research, expecting to stay in the lab. But I kept noticing talented young people quietly buckling under the pressure of career and family expectations — struggling with a weight no one had taught them how to carry. That realization changed everything, and I pursued a second Master's in Psychology, bringing my scientific rigor with me rather than leaving it behind.
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink-muted sm:text-lg">
            Today, my work sits at the intersection of both worlds — applying evidence-based thinking to the insights of psychology, building a mentoring approach grounded in real research, not guesswork or motivation. Every technique I teach is built on that same foundation: evidence over assumption, process over quick fixes. This is the work I was looking for all along — I just didn't know it yet when I started in that lab.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <blockquote className="mt-8 border-l-[3px] border-peach-dark pl-6 font-heading text-lg font-semibold italic leading-relaxed text-ink sm:text-xl">
            "What I teach isn't motivational fluff — it's grounded in real processes happening in the body, mind,
            and soul, backed by clinical research and proven techniques."
          </blockquote>
        </Reveal>
      </div>
    </div>
  </section>
);
